'use client';

import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Footer from './Footer';
import MaintenanceWrapper from './MaintenanceWrapper';
import SiteHelper from './SiteHelper';
import TopNavbar from './TopNavbar';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { apiGetMe } from '../helpers/auth';
import BanGuard from './BanGuard';

export default function ScrollableLayout({ children, maintenance = null }) {
  const [user, setUser] = useState(null);
  const pathname = usePathname();

  useEffect(() => {
    apiGetMe()
      .then((data) => setUser(data?.user ?? null))
      .catch(() => setUser(null));
  }, [pathname]);

  // Panel and admin pages handle their own layout (PanelLayout with sidebar)
  const isPanelPage = pathname.startsWith('/panel') || pathname.startsWith('/admin') || pathname.startsWith('/subscriptions');

  if (isPanelPage) {
    // Panel pages render children directly — PanelLayout provides its own sidebar/header
    return (
      <TooltipPrimitive.Provider>
        <div className="flex flex-col min-h-screen">
          <TopNavbar user={user} />
          <MaintenanceWrapper initial={maintenance}>
            <BanGuard>
              <div className="flex-1">{children}</div>
            </BanGuard>
          </MaintenanceWrapper>
          <SiteHelper />
        </div>
      </TooltipPrimitive.Provider>
    );
  }

  // Regular pages: top navbar + footer
  return (
    <TooltipPrimitive.Provider>
      <div className="flex flex-col min-h-screen">
        <TopNavbar user={user} />
        <MaintenanceWrapper initial={maintenance}>
          <BanGuard>
            <div className="flex-1">{children}</div>
          </BanGuard>
        </MaintenanceWrapper>
        <Footer />
        <SiteHelper />
      </div>
    </TooltipPrimitive.Provider>
  );
}

